import React, { useState } from 'react';
import { Checkbox, Icon, Modal } from 'semantic-ui-react';

import Button from '../../../components/Button';
import { getRemainingAttempts } from '../utils/biometryCopy';

type Props = {
  open: boolean;
  loading?: boolean;
  attemptCount?: number;
  maxAttempts?: number;
  subjectLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
};

const RetryBiometryConfirmModal: React.FC<Props> = ({
  open,
  loading = false,
  attemptCount = 0,
  maxAttempts = 3,
  subjectLabel = 'recebedor',
  onConfirm,
  onClose
}) => {
  const [confirmed, setConfirmed] = useState(false);
  const remainingAfterRetry = Math.max(0, getRemainingAttempts(attemptCount, maxAttempts) - 1);

  const handleClose = () => {
    setConfirmed(false);
    onClose();
  };

  const handleConfirm = () => {
    if (!confirmed || loading) return;
    onConfirm();
  };

  return (
    <Modal open={open} onClose={handleClose} size="small" closeIcon>
      <Modal.Header>
        <Icon name="exclamation triangle" color="orange" />
        Tentar biometria novamente
      </Modal.Header>
      <Modal.Content>
        <p style={{ marginTop: 0 }}>
          A validação anterior do {subjectLabel} foi recusada na Pagar.me. Ao confirmar:
        </p>
        <ul style={{ marginTop: 8, marginBottom: 16, paddingLeft: 20 }}>
          <li>Um novo recebedor será criado na Pagar.me</li>
          <li>O link anterior de biometria deixará de valer</li>
          <li>Você precisará concluir a prova de vida novamente</li>
        </ul>
        <p style={{ marginBottom: 16 }}>
          Tentativas restantes após esta ação:{' '}
          <strong>{remainingAfterRetry}</strong>
        </p>
        <Checkbox
          label="Entendo que um novo cadastro será criado na Pagar.me"
          checked={confirmed}
          onChange={(_, data) => setConfirmed(Boolean(data.checked))}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" light text="Cancelar" onClick={handleClose} disabled={loading} />
        <Button
          type="button"
          text="Confirmar e tentar novamente"
          onClick={handleConfirm}
          loading={loading}
          disabled={!confirmed || loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default RetryBiometryConfirmModal;
